// src/components/realisations/PortfolioCTA.js
import React from 'react';
import { Link } from 'react-router-dom';
import '../home/FinalCTASection.css';

function PortfolioCTA() {
  return (
    <section className="final-cta-container">
      <h2>Vous avez un projet en tête ?</h2>
      <p>
        Inspiré par nos réalisations ? Discutons de la manière dont nous pouvons transformer
        votre vision en une solution web performante et sur mesure.
      </p>
      <Link to="/contact" className="btn btn-primary btn-cta-final">
        Contactez-nous pour commencer <span className="cta-arrow" aria-hidden="true">&rarr;</span>
      </Link>
    </section>
  );
}

export default PortfolioCTA;